nc_initStickySidebar('.wizard-progress-overview', {containerSelector: '.content_sidebar', innerWrapperSelector: '.wizard-progress-overview-inner', topSpacing: 150, bottomSpacing: 80});

